import React from 'react';

export default function DuplicateBanner(props) {
  const { duplicateBanners } = props;

  const duplicateMessage = duplicateBanners.map((duplicate) => {
        return duplicate.message;
  }).reduce((prev, elem) => prev + "\n\n" + elem);

  return (
    duplicateMessage && (
        // eslint-disable-next-line react/no-array-index-key
        <div className="flex-column-top mr-1 pt-1">
          <div className={`row`}>
              <span
                className="tag lox-banner-tags lox-no-border has-tooltip-arrow has-tooltip-multiline has-tooltip-bottom has-tooltip-primary is-danger no-radius"
                data-tooltip={duplicateMessage}
              >
                Duplicated
              </span>
            </div>
        </div>
      )
  );
}
